// extracted by mini-css-extract-plugin
export default {"addressAction":"D6-z","loading":"E6-z"};